export default "__VITE_ASSET__Bk$K0p1y__"